/* eslint-disable-next-line import/no-unresolved */
import 'vite/modulepreload-polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import {
  Switch, Route, Redirect, BrowserRouter
} from 'react-router-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware, Store as Store_ } from 'redux';
import thunk from 'redux-thunk';
import { OidcProvider, loadUser } from 'redux-oidc';
import LogoutCallback from './oidc/logout-callback';
import Logout from './oidc/logout';
import TokenCallback from './oidc/token-callback';

import reducers from '../redux/reducers/index';
import RequiredDocument from './required-documents/required-documents';
import RequiredDocumentHistory from './required-documents-history/required-documents-history';
import CreateNewCommercialRequest from './create-new-commercial-request/create-new-commercial-request';
import CreateNewConsumerRequest from './create-new-consumer-request/create-new-consumer-request';
import CurrentRequests from './current-requests/current-requests';
import LoanApplicationHistory from './loan-application-history/loan-application-history';
import Home from './home/home';
import Layout from './layout/index';
import PageMissing from './page-missing/page-missing';
import userManager from '../utils/userManager';
import { AppState as AppState_ } from '../redux/app-state';

// eslint-disable-next-line import/no-unresolved
import '@jkhy/vsg-design-system/dist/styles.css';

const store: Store_<AppState_> = createStore(reducers, undefined, applyMiddleware(thunk));

loadUser(store, userManager).then(() => {
  const ReqDocuments = props => (
    <Layout {...props}>
      <RequiredDocument />
    </Layout>
  );

  const HomeLst = props => (
    <Layout {...props}>
      <Home />
    </Layout>
  );

  const ReqDocumentsHistory = props => (
    <Layout {...props}>
      <RequiredDocumentHistory />
    </Layout>
  );

  const CreateNewCommercialReq = props => (
    <Layout {...props}>
      <CreateNewCommercialRequest />
    </Layout>
  );

  const CreateNewConsumerReq = props => (
    <Layout {...props}>
      <CreateNewConsumerRequest />
    </Layout>
  );

  const LoanAppHistory = props => (
    <Layout {...props}>
      <LoanApplicationHistory />
    </Layout>
  );

  const CreateCurrentRequests = props => (
    <Layout {...props}>
      <CurrentRequests />
    </Layout>
  );

  const App = () => (
    <Provider store={store}>
      <OidcProvider store={store} userManager={userManager}>
        <BrowserRouter basename={window.APP_NAME}>
          <Switch>
            <Route
              exact
              path="/"
              render={_ => {
                const to = `/home${_.location.search}`;
                return <Redirect to={to} />;
              }}
            />
            <Route exact path="/token-callback" component={TokenCallback} />
            <Route exact path="/logout-callback/:autologout?/" component={LogoutCallback} />
            <Route exact path="/home" render={props => HomeLst(props)} />
            <Route exact path="/required" render={props => ReqDocuments(props)} />
            <Route exact path="/history" render={props => ReqDocumentsHistory(props)} />
            <Route exact path="/logout/:autologout?/" component={Logout} />
            <Route exact path="/create-new-commercial-request" render={props => CreateNewCommercialReq(props)} />
            <Route exact path="/create-new-consumer-request" render={props => CreateNewConsumerReq(props)} />
            <Route exact path="/current-requests" render={props => CreateCurrentRequests(props)} />
            <Route exact path="/loan-application-history" render={props => LoanAppHistory(props)} />
            <Route
              exact
              path="*"
              render={(props) => (
                <PageMissing
                  statusCode="404"
                  errMsg="The page you are looking for was not found.!"
                  {...props}
                />
              )}
            />
          </Switch>
        </BrowserRouter>
      </OidcProvider>
    </Provider>
  );

  createRoot(document.getElementById('app')!).render(<App />);
});
